import { conversationsApi } from "@/services/conversation-service";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useConversationScope } from "@/hooks/useConversationScope";
import { conversationQueryKeys } from "@/features/playground/conversation-query-keys";

type TPayload = Parameters<typeof conversationsApi.updateConversation>[1];
export const useRenameConversation = (id: string) => {
  const queryClient = useQueryClient();
  const { scope, requestScope } = useConversationScope();

  const mutation = useMutation({
    mutationFn: (newName: string) => {
      return conversationsApi.updateConversation(
        id,
        { name: newName } as TPayload,
        requestScope,
      );
    },
    onMutate: () => ({ operationScope: scope }),
    onSuccess: (_data, _newName, context) => {
      const operationScope = context?.operationScope ?? scope;
      queryClient.invalidateQueries({
        queryKey: conversationQueryKeys.lists(operationScope),
      });
      queryClient.invalidateQueries({
        queryKey: conversationQueryKeys.detailConversation(operationScope, id),
      });
    },
  });
  return mutation;
};
